<div class="dashboard-container">
  <intelishs-page-header title="Dashboard" subtitle="Resumen de Recursos Humanos" />

  <!-- ══════ ROW 1: Stats principales (3 cards) ══════ -->
  <div class="stats-grid stats-grid--3">
    <intelishs-stat-card
      icon="team"
      color="blue"
      label="Total de Empleados"
      [value]="totalEmpleados()"
      [description]="empleadosActivos() + ' activos · ' + empleadosInactivos() + ' inactivos'"
      [clickable]="true"
      (select)="irA('/empleados')"
    />

    <intelishs-stat-card
      icon="clock-circle"
      color="orange"
      label="Vacaciones Pendientes Por Autorizar"
      [value]="totalPendientes()"
      [description]="pendientesDirector() + ' director · ' + pendientesRH() + ' RH'"
      [clickable]="true"
      (select)="irA('/autorizaciones-rh')"
    />

    <intelishs-stat-card
      icon="calendar"
      color="teal"
      label="En Vacaciones Hoy"
      [value]="empleadosEnVacaciones()"
      [description]="proximasVacaciones7d() + ' inician esta semana'"
      [clickable]="true"
      (select)="irA('/calendario')"
    />
  </div>

  <!-- ══════ ROW 3: Gráficas principales ══════ -->
  <div class="bottom-grid">
    <!-- Empleados por Dirección (bar chart) -->
    <div class="panel-card">
      <intelishs-section-header title="Empleados por Dirección" />
      <div class="bar-chart">
        @for (item of empleadosPorDireccion(); track item.label) {
          <div class="bar-chart-row">
            <span class="bar-chart-label" [nz-tooltip]="item.label">{{ item.label }}</span>
            <div class="bar-chart-track">
              <div
                class="bar-chart-fill"
                [style.width.%]="item.pct"
                [style.background]="item.color"
              ></div>
            </div>
            <span class="bar-chart-count">{{ item.count }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Ingresos Recientes (movido aquí desde la fila inferior) -->
    <div class="panel-card">
      <intelishs-section-header title="Ingresos Más Recientes" />
      @if (ingresosRecientes().length === 0) {
        <intelishs-empty-state icon="inbox" message="No hay ingresos registrados" />
      } @else {
        <div class="dash-list">
          @for (e of ingresosRecientes(); track e.idInterno) {
            <intelishs-list-row
              icon="user"
              color="green"
              [clickable]="true"
              (select)="irA('/empleados')"
            >
              <intelishs-cell-stack [main]="e.nombre" [meta]="e.idInterno + ' · ' + e.puesto" />
              <ng-container slot="derecha">
                <span class="sinay-list-row__dato">{{ e.fechaIngreso | date: 'dd/MM/yyyy' }}</span>
                <span class="sinay-list-row__meta">{{ e.direccion }}</span>
              </ng-container>
            </intelishs-list-row>
          }
        </div>
      }
    </div>
  </div>

  <!-- ══════ ROW 4: Vacaciones por mes ══════ -->
  <div class="panel-card full-width dashboard-row">
    <div class="panel-card-head">
      <intelishs-section-header title="Vacaciones por Mes" />
      <div class="panel-card-head-nav">
        <span class="panel-card-head-nota">
          {{ totalSolicitudesAnio() }} solicitudes en {{ anioSeleccionado() }}
        </span>
        <button
          nz-button
          nzShape="circle"
          nzSize="small"
          [disabled]="!puedeIrAtras()"
          (click)="irAnioAnterior()"
          [attr.aria-label]="'Año anterior'"
        >
          <nz-icon nzType="left" />
        </button>
        <span class="panel-card-head-anio">
          {{ anioSeleccionado() }}
        </span>
        <button
          nz-button
          nzShape="circle"
          nzSize="small"
          [disabled]="!puedeIrAdelante()"
          (click)="irAnioSiguiente()"
          [attr.aria-label]="'Año siguiente'"
        >
          <nz-icon nzType="right" />
        </button>
      </div>
    </div>
    <div class="month-chart">
      @for (item of vacacionesPorMes(); track item.mes) {
        <div class="month-chart-col">
          <span class="month-chart-count">{{ item.count || '' }}</span>
          <div class="month-chart-bar-track">
            <div
              class="month-chart-bar"
              [style.height.%]="item.pct"
              [style.background]="item.count > 0 ? '#13c2c2' : '#f0f0f0'"
            ></div>
          </div>
          <span class="month-chart-label">{{ item.mes }}</span>
        </div>
      }
    </div>
  </div>

  <!-- ══════ ROW 5: Listas ══════ -->
  <div class="bottom-grid dashboard-row">
    <!-- Próximas Vacaciones -->
    <div class="panel-card">
      <intelishs-section-header title="Próximas Vacaciones (30 días)" />
      @if (proximasVacaciones().length === 0) {
        <intelishs-empty-state icon="smile" message="No hay vacaciones en curso ni próximas" />
      } @else {
        <div class="dash-list">
          @for (v of proximasVacaciones(); track v.nombre + v.fechaInicio) {
            <!-- En curso → calendario verde (vacación vigente hoy).
                 Próximamente → play-circle teal (vacación que arranca pronto). -->
            <intelishs-list-row
              [icon]="v.enCurso ? 'calendar' : 'play-circle'"
              [color]="v.enCurso ? 'green' : 'teal'"
            >
              <intelishs-cell-stack [main]="v.nombre" [meta]="v.area + ' · ' + v.dias + ' días'" />
              <ng-container slot="derecha">
                <span class="sinay-list-row__dato">
                  {{ v.fechaInicio | date: 'dd/MM/yyyy' }} → {{ v.fechaFin | date: 'dd/MM/yyyy' }}
                </span>
                <intelishs-status-text [tone]="v.enCurso ? 'ok' : 'progreso'">
                  {{ v.enCurso ? 'En curso' : 'Próximamente' }}
                </intelishs-status-text>
              </ng-container>
            </intelishs-list-row>
          }
        </div>
      }
    </div>

    <!-- Vencimientos Próximos: empleados con días disponibles del ciclo
         anterior que vencen en los próximos 30 días. -->
    <div class="panel-card">
      <intelishs-section-header title="Vencimientos Próximos (30 días)" />
      @if (vencimientosProximos().length === 0) {
        <intelishs-empty-state
          icon="check-circle"
          message="Nadie tiene días por vencer en los próximos 30 días"
        />
      } @else {
        <div class="dash-list">
          @for (v of vencimientosProximos(); track v.idInterno) {
            <intelishs-list-row
              icon="hourglass"
              color="orange"
              [clickable]="true"
              (select)="irA('/mis-autorizaciones')"
            >
              <intelishs-cell-stack [main]="v.nombre" [meta]="v.idInterno + ' · ' + v.area" />
              <ng-container slot="derecha">
                <span class="sinay-list-row__dato">
                  {{ v.fechaVencimiento | date: 'dd/MM/yyyy' }}
                </span>
                <span class="sinay-list-row__meta">{{ v.diasDisponibles }} días por usar</span>
              </ng-container>
            </intelishs-list-row>
          }
        </div>
      }
    </div>
  </div>
</div>
